/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo} from '../Helpers'
import {client} from '../Client';

class CommesseComboFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {idCommessa: props.idCommessa}
        this.state = {
            fields: fields,
            dropdownCommesseLoading: false,
            dropdownCommesseList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboCommesse = this.comboCommesse.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.dataDal !== this.props.dataDal ||
            nextProps.dataAl !== this.props.dataAl ||
            nextProps.idUtente !== this.props.idUtente
        ){
            this.comboCommesse(nextProps.dataDal, nextProps.dataAl, nextProps.idUtente);
        }
        if (nextProps.idCommessa !== this.state.fields.idCommessa)
        {
            let fields = this.state.fields;
            fields.idCommessa = nextProps.idCommessa;
            this.setState({fields},
                ()=>{
                    if ( this.state.fields.idCommessa !== undefined){
                        this.props.onChange(
                            this.state.fields.idCommessa,
                            this.getDDText(this.state.fields.idCommessa, this.state.dropdownCommesseList)
                        );
                    }
                });
        }
    }

    componentDidMount(){
        this.comboCommesse();
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '';
    }

    comboCommesse(dataDal, dataAl, idUtente){
        this.setState({ dropdownCommesseLoading: true });

        if (dataDal !== undefined && dataAl !== undefined && idUtente !== undefined){
            client.loadCommesseTutteListPerPeriodoUtente(dataDal, dataAl, idUtente).then((response) => {
                if (response.ok)
                {
                    response.json().then((data)=>{

                        let items = [{idCommessa: 0, nomeCompleto: 'Tutte'}];
                        items = items.concat(data.items);
                        this.setState({
                                dropdownCommesseLoading: false,
                                error: null,
                                dropdownCommesseList: arrayToCombo(items, "idCommessa", "nomeCompleto", "idCommessa", false)
                            },
                            ()=>{
                                if ( this.state.fields.idCommessa !== undefined){
                                    this.props.onChange(
                                        this.state.fields.idCommessa,
                                        this.getDDText(this.state.fields.idCommessa, this.state.dropdownCommesseList)
                                    );
                                }
                            })
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }            else
                {
                    response.json().then((errore) => {
                        let fieldErrorsText = []
                        let fieldErrors = {}
                        this.setState({
                            dropdownCommesseLoading: false,
                            fieldErrors: fieldErrors,
                            fieldErrorsText: fieldErrorsText,
                            errorTitle: '',
                            error: {title: errore.title, msg: errore.msg},
                            inError: true
                        });
                    });
                }
            }).catch((error) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownCommesseLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });
            });

        }
        else {
            client.loadCommesseTutteList().then((response) => {
                if (response.ok)
                {
                    response.json().then((data)=>{

                        let items = [{idCommessa: 0, nomeCompleto: 'Tutte'}];
                        items = items.concat(data.items);
                        this.setState({
                                dropdownCommesseLoading: false,
                                error: null,
                                dropdownCommesseList: arrayToCombo(items, "idCommessa", "nomeCompleto", "idCommessa", false)
                            },
                            ()=>{
                                if ( this.state.fields.idCommessa !== undefined){
                                    this.props.onChange(
                                        this.state.fields.idCommessa,
                                        this.getDDText(this.state.fields.idCommessa, this.state.dropdownCommesseList)
                                    );
                                }
                            })
                    })
                }
                else if (response.status === 401)
                {
                    this.props.history.push("/login")
                }            else
                {
                    response.json().then((errore) => {
                        let fieldErrorsText = []
                        let fieldErrors = {}
                        this.setState({
                            dropdownCommesseLoading: false,
                            fieldErrors: fieldErrors,
                            fieldErrorsText: fieldErrorsText,
                            errorTitle: '',
                            error: {title: errore.title, msg: errore.msg},
                            inError: true
                        });
                    });
                }
            }).catch((error) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownCommesseLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });
            });
        }



    }

    onInputChange(a1, b1) {
        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
            this.props.onChange(this.state.fields.idCommessa, this.getDDText(value, b1.options));
        }
    }

    render() {
        return (
            <div className="ui form">
                <div className="inline fields">
                    <Form.Field className="inline fields" width={16}>
                        <label>Commessa</label>
                        <Form.Dropdown width={16} style={{width:"100%"}} name='idCommessa' disabled={this.props.abilitato === false} loading={this.state.dropdownCommesseLoading} search selection options={this.state.dropdownCommesseList} value={this.state.fields.idCommessa} onChange={this.onInputChange}/>
                    </Form.Field>
                </div>
            </div>)
    }
}

CommesseComboFilter.PropTypes = {
    idCommessa: PropTypes.number.isRequired,
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    idUtente: PropTypes.number,
    dataDal: PropTypes.string,
    dataAl: PropTypes.string,
};

CommesseComboFilter.defaultProps = {
    idCommessa: undefined,
    abilitato: false
};
export default CommesseComboFilter;



/** WEBPACK FOOTER **
 ** ./src/components/CommesseComboFilter.js
 **/